import React from "react";
import PropTypes from "prop-types";
import A_TextField from "../../../Atoms/Inputs/TextFields/A_TextField";
import { NOTES_MAX_LENGTH } from "../../../../../domain/provision/provision.rules";
import useStyles from "./Provision.styles";

/** Notes (claude-code-UI-prompt.md §Screen structure 6, DFXX12): optional, max 2000 chars. */
const NotesSection = ({ notes, onChange, editable }) => {
  const classes = useStyles();
  return (
    <div className={classes.card} style={{ marginBottom: 0 }}>
      <div className={classes.cardHeader}>
        <span className={classes.cardHeaderTitle}>Notes</span>
      </div>
      <div className={classes.cardBody}>
        <p className={classes.subtle} style={{ marginTop: 0 }}>
          Add any additional context or commentary related to this provision.
        </p>
        <A_TextField
          id="provisionNotes"
          inputProps={{ placeholder: "Type your notes here…" }}
          defaultValue={notes || ""}
          onChange={(e) => onChange(e.target.value)}
          disabled={!editable}
          multiline
          rows={4}
          inputMaxLength={NOTES_MAX_LENGTH}
          variant="outlined"
          fullWidth
        />
        <div className={classes.subtle} style={{ textAlign: "right", marginTop: 6 }}>
          {(notes || "").length} / {NOTES_MAX_LENGTH}
        </div>
      </div>
    </div>
  );
};

NotesSection.propTypes = {
  notes: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  editable: PropTypes.bool,
};

export default NotesSection;
